import baseApi from './baseApi';

export interface AutosRelifCar {
  id: number;
  brand: string | null;
  model: string | null;
  version?: string | null;
  year?: number | null;
  price?: number | null;
  image?: string | null;
  km?: number | null;
  transmission?: string | null;
  fuelType?: string | null;
  hash?: string | null;
}

interface AutosRelifCarsResponse {
  newCars: AutosRelifCar[];
  usedCars: AutosRelifCar[];
}

interface CreateLeadRequest {
  phone: string;
  firstName: string;
  lastName: string;
  email?: string;
  rut?: string;
  brandOfInterest: string;
  modelOfInterest: string;
  source?: string;
  externalId?: string;
}

interface CreateLeadResponse {
  success: boolean;
  isNewClient?: boolean;
  client?: {
    id: number;
    phone: string;
    firstName: string;
    lastName: string;
  };
  message?: string;
}

const autosrelifApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAutosRelifCars: build.query<AutosRelifCarsResponse, void>({
      query: () => ({
        url: '/autosrelif/get-cars',
        method: 'GET',
      }),
      transformResponse: (response: AutosRelifCarsResponse) => response,
    }),
    createAutosRelifLead: build.mutation<CreateLeadResponse, CreateLeadRequest>({
      query: (body) => ({
        url: '/autosrelif/create-lead',
        method: 'POST',
        body,
      }),
      transformResponse: (response: CreateLeadResponse) => response,
    }),
  }),
  overrideExisting: false,
});

export const { useGetAutosRelifCarsQuery, useCreateAutosRelifLeadMutation } = autosrelifApi;
